<template>
  <div>
    <el-form
      :rules="rules"
      :model="usedForm"
      ref="formedForm"
      label-position="top"
      label-width="120px"
    >
      <el-row>
        <el-col :span="6">
          <el-form-item prop="date" label="Дата">
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="usedForm.date"
              type="date"
              @change="setDatastored"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item prop="ammount" label="" v-if="datastored !== null">
            Доступно на {{ usedForm.date }} для проведения операции:
            {{ datastored.amount - datastored.sumAmountGet }}
            {{ datastored.pss93UnitInfo.name }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-row>
            <el-form-item prop="store" label="Количество">
              <el-input v-model="usedForm.store"></el-input>
            </el-form-item>
          </el-row>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Единица измерения">
            <el-input v-model="waste.pss93UnitInfo.name" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <p
          style="color: red"
          v-if="
            datastored !== null &&
            parseFloat(usedForm.store.toString().replace(',', '.')) >
              valueDatastor
          "
        >
          Ошибка! Превышение доступного количества отхода
        </p>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item prop="pss19Info" label="Использовано для">
            <el-select
              clearable
              placeholder="Наименование направления"
              class="searchPole"
              value-key="id"
              v-model="usedForm.pss19Info"
              filterable
            >
              <el-option
                v-for="item in pss19DirectionOfUseInfoList"
                :key="item.id"
                :label="item.name"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="20" v-if="userId == 180">
          <el-button
            @click="passportAdd"
            type="primary"
            style="float: left"
            :disabled="
              parseFloat(usedForm.store.toString().replace(',', '.')) >
                valueDatastor ||
              block ||
              (new Date(
                usedForm.date.split('-')[0],
                usedForm.date.split('-')[1] - 1,
                usedForm.date.split('-')[2]
              ) < new Date(new Date().getFullYear(), 1, 1) &&
                (userId == 469 || userId == 470 || userId == 471)) ||
              (new Date(
                usedForm.date.split('-')[0],
                usedForm.date.split('-')[1] - 1,
                usedForm.date.split('-')[2]
              ) <= new Date(2025, 2, 31) &&
                (userId == 253 ||
                  userId == 254 ||
                  userId == 255 ||
                  userId == 256 ||
                  userId == 257 ||
                  userId == 258 ||
                  userId == 259 ||
                  userId == 260 ||
                  userId == 261 ||
                  userId == 262 ||
                  userId == 336)) ||
              (new Date(
                usedForm.date.split('-')[0],
                usedForm.date.split('-')[1] - 1,
                usedForm.date.split('-')[2]
              ) < new Date(new Date().getFullYear(), 2, 1) &&
                (userId == 482 || userId == 501)) ||
              (new Date(
                usedForm.date.split('-')[0],
                usedForm.date.split('-')[1] - 1,
                usedForm.date.split('-')[2]
              ) < new Date(this.dateMinus1month.getFullYear(), 0, 1) &&
                userId != 419 &&
                userId != 265 &&
                userId != 266 &&
                userId != 267 &&
                userId != 268 &&
                userId != 269 &&
                userId != 270 &&
                userId != 271 &&
                userId != 272 &&
                userId != 273 &&
                userId != 274 &&
                userId != 275 &&
                userId != 276 &&
                userId != 277 &&
                userId != 278 &&
                userId != 279 &&
                userId != 280 &&
                userId != 281 &&
                userId != 282 &&
                userId != 283 &&
                userId != 284 &&
                userId != 285 &&
                userId != 286 &&
                userId != 287 &&
                userId != 288 &&
                userId != 289 &&
                userId != 290 &&
                userId != 233 &&
                userId != 234 &&
                userId != 25 &&
                userId != 292 &&
                userId != 245 &&
                userId != 14 &&
                userId != 465 &&
                userId != 505 &&
                userId != 506 &&
                userId != 507 &&
                userId != 428 &&
                userId != 124 &&
                userId != 557 && 
                userId != 559 &&
                userId != 587 &&
                userId != 425 &&
                userId != 180 && userId != 344 && userId != 96)
            "
            >Сопроводительный паспорт</el-button
          >
        </el-col>
        <el-col :span="userId == 180 ? 4 : 24">
          <el-button
            @click="save"
            type="primary"
            style="float: right"
            :disabled="
              parseFloat(usedForm.store.toString().replace(',', '.')) >
                valueDatastor ||
              block ||
              (new Date(
                usedForm.date.split('-')[0],
                usedForm.date.split('-')[1] - 1,
                usedForm.date.split('-')[2]
              ) < new Date(new Date().getFullYear(), 1, 1) &&
                (userId == 469 || userId == 470 || userId == 471)) ||
              (new Date(
                usedForm.date.split('-')[0],
                usedForm.date.split('-')[1] - 1,
                usedForm.date.split('-')[2]
              ) <= new Date(2025, 2, 31) &&
                (userId == 253 ||
                  userId == 254 ||
                  userId == 255 ||
                  userId == 256 ||
                  userId == 257 ||
                  userId == 258 ||
                  userId == 259 ||
                  userId == 260 ||
                  userId == 261 ||
                  userId == 262 ||
                  userId == 336)) ||
              (new Date(
                usedForm.date.split('-')[0],
                usedForm.date.split('-')[1] - 1,
                usedForm.date.split('-')[2]
              ) < new Date(new Date().getFullYear(), 2, 1) &&
                (userId == 482 || userId == 501)) ||
              (new Date(
                usedForm.date.split('-')[0],
                usedForm.date.split('-')[1] - 1,
                usedForm.date.split('-')[2]
              ) < new Date(this.dateMinus1month.getFullYear(), 0, 1) &&
                userId != 419 &&
                userId != 265 &&
                userId != 266 &&
                userId != 267 &&
                userId != 268 &&
                userId != 269 &&
                userId != 270 &&
                userId != 271 &&
                userId != 272 &&
                userId != 273 &&
                userId != 274 &&
                userId != 275 &&
                userId != 276 &&
                userId != 277 &&
                userId != 278 &&
                userId != 279 &&
                userId != 280 &&
                userId != 281 &&
                userId != 282 &&
                userId != 283 &&
                userId != 284 &&
                userId != 285 &&
                userId != 286 &&
                userId != 287 &&
                userId != 288 &&
                userId != 289 &&
                userId != 290 &&
                userId != 233 &&
                userId != 234 &&
                userId != 25 &&
                userId != 292 &&
                userId != 245 &&
                userId != 14 &&
                userId != 465 &&
                userId != 505 &&
                userId != 506 &&
                userId != 507 &&
                userId != 428 &&
                userId != 124 &&
                userId != 557 && 
                userId != 559 &&
                userId != 587 &&
                userId != 425 &&
                userId != 180 && userId != 344 && userId != 96)
            "
            >Сохранить</el-button
          >
        </el-col>
      </el-row>
    </el-form>

    <custom-modal :visible="showModal === 'dataPasport'">
      <disposal-pasport-form
        :action="passport"
        :waste="wastes"
        @addPasportToTable="addPasportToTable"
      ></disposal-pasport-form>
    </custom-modal>
  </div>
</template>

<script>
import notification from "@/mixins/notification";
import Cookies from "js-cookie";
import disposalPasportForm from "@/components/ecologist/disposal/disposalPasport";
import CustomModal from "@/components/customModal";
import { mapGetters } from "vuex";
import { AXIOS } from "@/AXIOS/http-common";
export default {
  name: "usedModal",
  components: { disposalPasportForm, CustomModal },
  props: ["waste"],
  mixins: [notification],
  data() {
    return {
      passport: {
        number: null,
        contractor1: null,
        contractor2: { content: 0 },
        contractor3: null,
        data: null,
        vehicle: null,
        full_name: null,
        tara_name: null,
        tara_vight: null,
        vehicle_vight: null,
        number_card: null,
        owner: null,
        ownerr: null,
        transfer: null,
        transferr: null,
        ca1: "Ручной ввод",
        contractor1r: null,
        ca2: "Ручной ввод",
        contractor2r: null,
        ca3: "Ручной ввод",
        contractor3r: null,
        egr_full_name: null,
        chek_null_value: false,
        fileType: ".pdf",
        modal: "dataEntry",
        tr: "Ответственное лицо",
        ow: "Ответственное лицо",
        rules: {
          rul: [{ required: true, message: "Заполните поле", trigger: "blur" }],
        },
      },
      wastes: null,
      userId: Cookies.get("userId"),
      block: false,
      dateDatastore: null,
      valueDatastor: 0,
      datastored: null,
      pss19DirectionOfUseInfoList: null,
      actionId: 5,
      usedForm: {
        amount: this.waste.amount,
        store: "0",
        date: "",

        pss19Info: null,
      },
      rules: {
        store: [
          { required: true, message: "Введите количество", trigger: "blur" },
        ],

        pss19Info: [
          {
            required: true,
            message: "Заполните поле",
            trigger: "blur",
          },
        ],

        date: [{ required: true, message: "Введите дату", trigger: "blur" }],
      },
      dateMinus1month: new Date(),
    };
  },

  methods: {
    async GetNumberPassport() {
      return await AXIOS.get("report/get/NumberPass").then((response) => {
        this.passport.number = response.data.numb;
        this.passport.egr_full_name = response.data.egr_full_name;
        this.passport.contractor1r = response.data.egr_full_name;
        this.passport.contractor2r = response.data.egr_full_name;
        this.passport.contractor3r = response.data.egr_full_name;
      });
    },
    async passportAdd() {
      await this.GetNumberPassport();
      this.passport.data =
        this.usedForm.date.split("-")[2] +
        "." +
        this.usedForm.date.split("-")[1] +
        "." +
        this.usedForm.date.split("-")[0];
      //if (item.Contractors !== undefined)
      this.$store.dispatch("setShowModal", "dataPasport");
    },
    addPasportToTable(item) {
      console.log(this.showModal);
      this.passport = item;
      this.usedForm.passport = item; //.action;
      //this.wastes[0]=item.wastes;
      this.save();
    },
    async setDatastored() {
      await this.$store.dispatch("getBlockForUser",this.usedForm.date).then((response) => {
        if(response.data == true)
          {
            this.block=true;
            this.message(
              "Внимание! Заблокировано главным экологом!",
              "error",
              true
            );
            return;
          }
      });
      if (
        (new Date(
          this.usedForm.date.split("-")[0],
          this.usedForm.date.split("-")[1] - 1,
          this.usedForm.date.split("-")[2]
        ) <= new Date(2025, 2, 31) &&
          (this.userId == 253 ||
            this.userId == 254 ||
            this.userId == 255 ||
            this.userId == 256 ||
            this.userId == 257 ||
            this.userId == 258 ||
            this.userId == 259 ||
            this.userId == 260 ||
            this.userId == 261 ||
            this.userId == 262 ||
            this.userId == 336)) ||
        (new Date(
          this.usedForm.date.split("-")[0],
          this.usedForm.date.split("-")[1] - 1,
          this.usedForm.date.split("-")[2]
        ) < new Date(this.dateMinus1month.getFullYear(), 0, 1) &&
          this.userId != 419 &&
          this.userId != 265 &&
          this.userId != 266 &&
          this.userId != 267 &&
          this.userId != 268 &&
          this.userId != 269 &&
          this.userId != 270 &&
          this.userId != 271 &&
          this.userId != 272 &&
          this.userId != 273 &&
          this.userId != 274 &&
          this.userId != 275 &&
          this.userId != 276 &&
          this.userId != 277 &&
          this.userId != 278 &&
          this.userId != 279 &&
          this.userId != 280 &&
          this.userId != 281 &&
          this.userId != 282 &&
          this.userId != 283 &&
          this.userId != 284 &&
          this.userId != 285 &&
          this.userId != 286 &&
          this.userId != 287 &&
          this.userId != 288 &&
          this.userId != 289 &&
          this.userId != 290 &&
          this.userId != 233 &&
          this.userId != 234 &&
          this.userId != 25 &&
          this.userId != 292 &&
          this.userId != 245 &&
          this.userId != 14 &&
          this.userId != 465 &&
          this.userId != 505 &&
          this.userId != 506 &&
          this.userId != 507 &&
          this.userId != 428 &&
          this.userId != 124 &&
          this.userId != 557&&
          this.userId != 559 &&
          this.userId != 587 &&
          this.userId != 425 &&
          this.userId != 180 && this.userId != 344 && this.userId != 96 && this.userId != 344 && this.userId != 96)
      )
        this.message(
          "Внимание! Внесение данных за " +
            new Date(this.validat().item.date).getFullYear() +
            " год ограничено. Закрыт отчетный период",
          "error",
          true
        );
      this.getDatastored().then((response) => {
        if (response.data == true) {
          this.block = true;
          this.message("Внимание! Цепочка устарела!", "error", true);
          return;
        }
        if (response.data == false) {
          this.block = true;
          this.message(
            "Внимание! Цепочка не начала действовать!",
            "error",
            true
          );
          return;
        }
        this.block = false;
        this.datastored = response.data;
        this.valueDatastor =
          this.datastored.amount - this.datastored.sumAmountGet;
        this.dateDatastore = Date.parse(response.data.path);
        if (this.dateDatastore > Date.parse(this.usedForm.date, "yyyy-MM-dd"))
          this.message(
            "Внимание! Внесение информации на данной вкладке приведет к перерасчету количества отходов и изменениям в отчетной документации. Будьте внимательны при заполнении!",
            "error",
            true
          );
      });
    },
    async getDatastored() {
      let data = { date: "", techProcessHasWasteId: "" };
      data.date = this.usedForm.date;
      data.techProcessHasWasteId = this.waste.techProcessHasWasteId;
      return await this.$store.dispatch("getDataStored", data);
    },
    getPss19DirectionOfUseInfoList() {
      this.getSubClassifierById(19).then((response) => {
        this.pss19DirectionOfUseInfoList = response.data.content;
      });
    },

    async getSubClassifierById(id) {
      let data = {
        id: id,
        size: 100,
        page: 0,
      };
      return await this.$store.dispatch(
        "getAllDataSubClassifierForSelect",
        data
      );
    },
    validat() {
      let i = 0;
      if (this.usedForm.date == "" || this.usedForm.store == "")
        //{this.ErrorMasseg("Внимание! Заполните всте поля");
        i = 1;
      if (
        (new Date(
          this.usedForm.date.split("-")[0],
          this.usedForm.date.split("-")[1] - 1,
          this.usedForm.date.split("-")[2]
        ) <= new Date(2025, 2, 31) &&
          (this.userId == 253 ||
            this.userId == 254 ||
            this.userId == 255 ||
            this.userId == 256 ||
            this.userId == 257 ||
            this.userId == 258 ||
            this.userId == 259 ||
            this.userId == 260 ||
            this.userId == 261 ||
            this.userId == 262 ||
            this.userId == 336)) ||
        (new Date(
          this.usedForm.date.split("-")[0],
          this.usedForm.date.split("-")[1] - 1,
          this.usedForm.date.split("-")[2]
        ) < new Date(this.dateMinus1month.getFullYear(), 0, 1) &&
          this.userId != 419 &&
          this.userId != 265 &&
          this.userId != 266 &&
          this.userId != 267 &&
          this.userId != 268 &&
          this.userId != 269 &&
          this.userId != 270 &&
          this.userId != 271 &&
          this.userId != 272 &&
          this.userId != 273 &&
          this.userId != 274 &&
          this.userId != 275 &&
          this.userId != 276 &&
          this.userId != 277 &&
          this.userId != 278 &&
          this.userId != 279 &&
          this.userId != 280 &&
          this.userId != 281 &&
          this.userId != 282 &&
          this.userId != 283 &&
          this.userId != 284 &&
          this.userId != 285 &&
          this.userId != 286 &&
          this.userId != 287 &&
          this.userId != 288 &&
          this.userId != 289 &&
          this.userId != 290 &&
          this.userId != 233 &&
          this.userId != 234 &&
          this.userId != 25 &&
          this.userId != 292 &&
          this.userId != 245 &&
          this.userId != 14 &&
          this.userId != 465 &&
          this.userId != 505 &&
          this.userId != 506 &&
          this.userId != 507 &&
          this.userId != 428 &&
          this.userId != 124 &&
          this.userId != 557&&
          this.userId != 559 &&
          this.userId != 587 &&
          this.userId != 425 &&
          this.userId != 180 && this.userId != 344 && this.userId != 96 && this.userId != 344 && this.userId != 96)
      )
        //{this.ErrorMasseg("Внимание! Дата одного из значений меньше чем "+new Date().getFullYear()+" год");
        i = 2;
      return { id: i, item: this.usedForm };
    },
    save() {
      switch (this.validat().id) {
        case 1:
          this.ErrorMasseg("Внимание! Заполните все поля");
          return;
        case 2:
          this.ErrorMasseg(
            "Внимание! Внесение данных за " +
              new Date(this.validat().item.date).getFullYear() +
              " год ограничено. Закрыт отчетный период"
          );
          return;
        case 0:
          break;
      }
      this.$refs["formedForm"].validate((valid) => {
        if (valid) {
          this.block = true;
          this.usedForm.amount = this.waste.amount;
          console.log("VALID", this.usedForm);
          this.$store
            .dispatch("receiveDataEntryForm", {
              modalData: this.usedForm,
              id: this.$route.params.processId,
              actionId: this.actionId,
            })
            .then(() => {
              this.$store.dispatch(
                "getMainPageForDataEntry",
                this.$route.params.processId
              );
              
              this.$store.dispatch(
                "getMainPageForDataEntryByPeriod",
                this.$route.params.processId
              );
              this.notification("Успешно", "Данные внесены", "success");
              this.$store.dispatch("setShowModal", null);
              this.$store.dispatch("setShowModal", false);
            })
            .catch(error => {
              this.block = false;
              console.log(error.statusText);
            });
        } else {
          return false;
        }
      });
    },
  },
  computed: {
    ...mapGetters({
      showModal: "GETSHOWMODAL",
      listContractors: "GETLISTCONTRACTORS",
      NumberPassport: "GETDATASTORED",
    }),
  },

  mounted() {
    this.dateMinus1month.setMonth(new Date().getMonth() - 1)
    this.getPss19DirectionOfUseInfoList();
  },
};
</script>

<style scoped></style>
